import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum NtakMainCategoryId {
  ACCOMMODATION_FEE = 1,
  TOURISM_TAX = 2,
  PUBLIC_BATH = 3,
  NATURAL_BATHING_AREA = 4,
  MUSEUM_CASTLE_PALACE = 5,
  TOURIST_TRANSPORT_INFRASTRUCTURE = 6,
  ADVENTURE_PARK = 7,
  ZOO = 8,
  AMUSEMENT_PARK = 9,
  PROTECTED_NATURAL_AREA = 10,
  MUSIC_AND_DANCE_EVENT = 13,
  FOOD = 14,
  SOFT_DRINKS_LOCALLY_PREPARED = 15,
  SOFT_DRINKS_NOT_LOCALLY_PREPARED = 16,
  ALCOHOLIC_BEVERAGES = 17,
  OTHER = 18,
}

export class NtakMainCategory extends Codebook<NtakMainCategoryId> {
  static readonly ACCOMMODATION_FEE = new NtakMainCategory(
    NtakMainCategoryId.ACCOMMODATION_FEE,
    () => $t('Accommodation fee'),
  )

  static readonly TOURISM_TAX = new NtakMainCategory(NtakMainCategoryId.TOURISM_TAX, () =>
    $t('Tourism tax'),
  )

  static readonly PUBLIC_BATH = new NtakMainCategory(NtakMainCategoryId.PUBLIC_BATH, () =>
    $t('Public bath'),
  )

  static readonly NATURAL_BATHING_AREA = new NtakMainCategory(
    NtakMainCategoryId.NATURAL_BATHING_AREA,
    () => $t('Natural bathing area'),
  )

  static readonly MUSEUM_CASTLE_PALACE = new NtakMainCategory(
    NtakMainCategoryId.MUSEUM_CASTLE_PALACE,
    () => $t('Museum, castle, palace'),
  )

  static readonly TOURIST_TRANSPORT_INFRASTRUCTURE = new NtakMainCategory(
    NtakMainCategoryId.TOURIST_TRANSPORT_INFRASTRUCTURE,
    () => $t('Tourist transport infrastructure'),
  )

  static readonly ADVENTURE_PARK = new NtakMainCategory(NtakMainCategoryId.ADVENTURE_PARK, () =>
    $t('Adventure park'),
  )

  static readonly ZOO = new NtakMainCategory(NtakMainCategoryId.ZOO, () => $t('Zoo'))

  static readonly AMUSEMENT_PARK = new NtakMainCategory(NtakMainCategoryId.AMUSEMENT_PARK, () =>
    $t('Amusement park'),
  )

  static readonly PROTECTED_NATURAL_AREA = new NtakMainCategory(
    NtakMainCategoryId.PROTECTED_NATURAL_AREA,
    () => $t('Protected natural area'),
  )

  static readonly MUSIC_AND_DANCE_EVENT = new NtakMainCategory(
    NtakMainCategoryId.MUSIC_AND_DANCE_EVENT,
    () => $t('Music and dance event'),
  )

  static readonly FOOD = new NtakMainCategory(NtakMainCategoryId.FOOD, () => $t('Food'))

  static readonly SOFT_DRINKS_LOCALLY_PREPARED = new NtakMainCategory(
    NtakMainCategoryId.SOFT_DRINKS_LOCALLY_PREPARED,
    () => $t('Soft drinks (locally prepared)'),
  )

  static readonly SOFT_DRINKS_NOT_LOCALLY_PREPARED = new NtakMainCategory(
    NtakMainCategoryId.SOFT_DRINKS_NOT_LOCALLY_PREPARED,
    () => $t('Soft drinks (not locally prepared)'),
  )

  static readonly ALCOHOLIC_BEVERAGES = new NtakMainCategory(
    NtakMainCategoryId.ALCOHOLIC_BEVERAGES,
    () => $t('Alcoholic beverages'),
  )

  static readonly OTHER = new NtakMainCategory(NtakMainCategoryId.OTHER, () => $t('Other'))

  private constructor(
    public readonly id: NtakMainCategoryId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
